import React, { useEffect } from 'react';
import Header from './Header';
import CompanyOverview from './CompanyOverview';
import Footer from './Footer';

const CompanyPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      {/* Add spacing for fixed header */}
      <div className="h-20"></div>
      <CompanyOverview />
      <Footer />
    </div>
  );
};

export default CompanyPage;
